import React, { useState } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { FORM_CONTROL_CLASS } from './constants'
import { useBreakpoints } from 'hooks'
import { getAddressComponents } from 'helpers/location'

import LocationAutoComplete from 'app/Location/LocationAutoComplete'
import WarningDot from 'components/Profile/WarningDot'

import checkmarkIcon from 'assets/icons/checkmark.svg'

const ProfileLocation = ({
  onLocationUpdate,
  initialLocation,
  inputClassName,
  inputStyles,
  showRequired,
  searchType,
}) => {
  const [location, setLocation] = useState('')
  const [locationEmpty, setLocationEmpty] = useState(false)
  const { md } = useBreakpoints()

  return (
    <div className="md:max-w-lg relative">
      <LocationAutoComplete
        showLocationSearch={true}
        focus={false}
        searchType={searchType}
        needsPlaceholder={!initialLocation && !location}
        initialAddress={location ? location : initialLocation ? initialLocation : ''}
        inputClassName={classnames(FORM_CONTROL_CLASS, inputClassName)}
        inputStyles={{ textAlign: md ? 'center' : 'left', ...inputStyles }}
        iconPosition="right"
        icon={
          location && !locationEmpty && <img className="w-5 mr-2 z-1" src={checkmarkIcon} alt="" />
        }
        onInputChange={e => {
          onLocationUpdate({ location: e })

          if (e !== location) {
            setLocationEmpty(true)
          }
        }}
        grabLocationSuccessFunction={latLng => {
          const components = getAddressComponents(latLng.location.address_components)
          const locationObj = {
            geoLat: latLng.lat,
            geoLng: latLng.lng,
            location: latLng.location.formatted_address,
            components,
          }

          setLocation(locationObj.location)
          onLocationUpdate(locationObj)
          setLocationEmpty(false)
        }}
      />
      {showRequired && locationEmpty && (
        <WarningDot className="absolute top-1/2 right-4 transform -translate-y-1/2" />
      )}
    </div>
  )
}

ProfileLocation.defaultProps = {
  initialLocation: 'User Location',
  searchType: '(cities)',
}

ProfileLocation.propTypes = {
  inputClassName: PropTypes.string,
  inputStyles: PropTypes.object,
}

export default ProfileLocation
